export const SHOW_LOG = true;
export const NO_DATA_FOUND_DESCRIPTION = "No records found."
export const PAGINATION_NUM_ENTRIES_LIST = [10, 25, 50, 100];
export const FORM_ACTION_TYPES = ["create", "edit", "view"];

export const NUMBER_PATTERN = /^\d+$/;
export const NAME_PATTERN = /^[A-Za-z ]+$/;
export const TOKEN_AUTH_VALIDATION_INTERVAL = 20;

export const SPECIAL_CHARS_PATTERN = /[`~!@#$%^*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;

export const STATUSES = {
    ERROR: {
        code: -1,
        text: "error"
    },
    SESSION_TIMEOUT: {
        code: -2,
        text: "timeout"
    },
    LOG_OUT: {
        code: -3,
        text: "logout"
    },
    WARNING: {
        code: -4,
        text: "warning"
    },
    BATCH_ERROR: {
        code: -5,
        text: "batch_error"
    },
    SUCCESS: {
        code: 1,
        text: "success"
    },
    NORMAL: {
        code: 0,
        text: "normal"
    },
};

export const ORG_TYPES = {
    PSO: {
        text: "PSO",
        types: {
            PSO: {
                id: 24,
                desc: "PSO"
            }
        }
    },
    Admin: {
        text: "Admin",
        types: {
            AHRQ: {
                id: 21,
                desc: "AHRQ"
            },
            NPSD: {
                id: 22,
                desc: "NPSD"
            },
            PPC: {
                id: 23,
                desc: "PPC"
            },
            Top_Level: {
                id: 25,
                desc: "Top Level"
            }
        }
    },
    Vendor: {
        text: "Vendor",
        types: {
            Vendor: {
                id: 26,
                desc: "Vendor"
            }
        }
    }
};

export const ORG_TYPE_IDS = {
    21: {
        text: "Admin",
        desc: "AHRQ"
    },
    22: {
        text: "Admin",
        desc: "NPSD"
    },
    23: {
        text: "Admin",
        desc: "PPC"
    },
    /*24: {
        text: "PSO",
        desc: "PSO"
    },*/
    25: {
        text: "Admin",
        desc: "Top Level"
    },
    /*26: {
        text: "Vendor",
        desc: "Vendor"
    }*/
};

export const MANAGE_PAGE_TYPES = {
    E: 'Edit',
    C: 'Create',
    V: 'View',
    L: 'List'
}

export const getFullUserRoleName = (name, values) => {
    var full = name;
    if (values.length > 0) {
        full = full + " (";
        for (var x = 0; x < values.length; x++) {

            if (x == values.length - 1) {
                full = full + values[x];
            }
            else {
                full = full + values[x] + ", ";
            }
        }
        full = full + ")";
    }

    return full;
}

export const USER_ROLES = {
    LEVEL1: {
        id: "Level1",
        name: "Level 1",
        includes: ["Help Center Access"],
        value: 10000
    },
    LEVEL2: {
        id: "Level2",
        name: "Level 2",
        includes: ["PSO Profile"],
        value: 10001
    },
    LEVEL3: {
        id: "Level3",
        name: "Level 3",
        includes: ["PSO Profile", "Patient Safety Data"],
        value: 10002
    },
    PSOADMIN: {
        id: "PSOAdmin",
        name: "PSO Administrator",
        includes: ["PSO Profile", "Patient Safety Data", "Vendor Authorization"],
        value: 10003
    },
    PSOPPCADMIN: {
        id: "PSOPPCAdmin",
        name: "PSOPPC Administrator",
        includes: ["PSO Profile", "Vendor Authorization", "Organization Administrator", "Submission Management Report"],
        value: 10004
    },
    PSOPPCMANAGER: {
        id: "PSOPPCManager",
        name: "PSOPPC Manager",
        includes: ["Account Status Report", "Submission Management Report"],
        value: 10005
    },
    AHRQUSER: {
        id: "AHRQUser",
        name: "AHRQ User",
        includes: ["Help Center Access"],
        value: 10006
    },
    AHRQMANAGER: {
        id: "AHRQManager",
        name: "AHRQ Manager",
        includes: ["Access Interactive Report"],
        value: 10007
    }
}

export const ERROR_MESSAGES = {
    GENERAL_ERROR: {
        title: "Error",
        message: "An error has occured."
    },
    DATA_ERROR: {
        title: "Data Error",
        message: "Unable to load data."
    }
}

export const BATCH_ERROR_MESSAGES = {
    BATCH_ERROR: {
        title: "Batch Error",
        message: "An error has occured."
    }
}

export const WARNING_MESSAGES = {
    WARNING: {
        title: "Warning",
        message: "An warning has occured."
    }
}

export const DEFAULT_STATE_VALUE = {
    status: STATUSES.NORMAL,
    popup: {
        visible: false,
        title: "",
        msg: ""
    },
    data: {}
}

export function WindowState (statusObj, popupObj, dataObj) {
    this.status = statusObj;
    this.popup = popupObj;/*{
        visible: false,
        title: "",
        msg: ""
    }*/
    this.data = dataObj;
}

export const DEFAULT_TEXT_INPUT = {


    value: '',
    validation: {
        required: false,
        isInvalid: false,
        errors: []
    },
    onChange: null,
    disabled: false,
    readOnly: false
}

export const PROFILE_FORM_FIELD_TYPES = {
    date: 'DATE',
    txt: 'TEXT',
    radio: 'RADIO',
    num: 'NUMBER',
    numnp: 'NUMBER_NP',
    otxt: 'ONLY_TEXT',
    innum: 'INDT_NUMBER',
    chk: 'CHECKBOX',
    schk: 'SINGLE_CHECKBOX',
    chknum: 'CHECKBOX_NUMBER'
}

export const PSO_PROFILE_STATUSES = {
    1: "In Progress",
    2: "Complete",
    3: "Submitted"
}

export const ROLES = {
    L1: {
        id: "Level1",
        name: "Level 1",
        value: 10000
    },
    L2: {
        id: "Level2",
        name: "Level 2",
        value: 10001
    },
    L3: {
        id: "Level3",
        name: "Level 3",
        value: 10002
    },
    PSOA: {
        id: "PSOAdmin",
        name: "PSO Administrator",
        value: 10003
    },
    PPCA: {
        id: "PSOPPCAdmin",
        name: "PSOPPC Administrator",
        value: 10004
    },
    PPCM: {
        id: "PSOPPCManager",
        name: "PSOPPC Manager",
        value: 10005
    },
    AUSER: {
        id: "AHRQUser",
        name: "AHRQ User",
        value: 10006
    },
    AM: {
        id: "AHRQManager",
        name: "AHRQ Manager",
        value: 10007
    }
}